import { COMPANY_GET, COMPANY_DELETE, COMPANY_UPDATE, COMPANY_LIST } from '../actions/companies'
import apiCall from './call'

const model = 'companies'

const state = {
  //
}

const getters = {
  //
}

const actions = {
  [COMPANY_LIST]: ({ commit, dispatch }, searchTerm) => {
    return new Promise((resolve, reject) => {
      apiCall({
        url: model,
        method: 'GET',
        qs: {
          search: searchTerm,
          paginate: 5
        }
      })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [COMPANY_GET]: ({ commit, dispatch }, companyId) => {
    return new Promise((resolve, reject) => {
      apiCall({ url: model + '/' + companyId })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [COMPANY_DELETE]: ({ commit, dispatch }, companyIds) => {
    let users = { ids: [companyIds] }
    return new Promise((resolve, reject) => {
      apiCall({ url: model, data: users, method: 'DELETE' })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [COMPANY_UPDATE]: ({ commit, dispatch }, company) => {
    return new Promise((resolve, reject) => {
      apiCall({ url: model + '/' + company.id, data: company, method: 'PUT' })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}

const mutations = {
  //
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/companies.js